const leadershipUrl = 'team/';

export default { leadershipUrl };
